var _module_exports ="<!-- Full - Create - BIA Profile -->\n<div bcm-bia-profile\n     box-tmpl=\"full\"\n     box-tmpl-behavior=\"create\"\n     box-model=\"biaProfile\">\n</div>";;
var path = '/app/Main/BCM/biaProfileAdd.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;